import React, { PureComponent } from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
  Tooltip,
} from 'recharts'
import { Props } from 'recharts/types/component/Label'
import styled from 'styled-components'

type StackProgressChartParam = {
  values: object
  names: string[]
  height?: number
  align?: 'left' | 'right' | 'center'
  unit?: string
}

const backgroundColors = ['#ff4444', '#ffafaf', '#dfff2b', '#a1fab0', '#00ff22']
const foregroundColors = ['black', 'black', 'black', 'black', 'black']

function StackProgressChart(props: StackProgressChartParam) {
  const data = [{ name: 'stack', ...props.values }]

  const values = Object.values(props.values)

  return (
    <Wrapper>
      <div className="content c-white">
        <ResponsiveContainer height={props.height || 40} width={'100%'}>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
            stackOffset="expand"
          >
            <Tooltip labelFormatter={() => '직업만족도'} />
            <XAxis hide type="number" />
            <YAxis
              type="category"
              dataKey="name"
              stroke="#fff"
              fontSize="12"
              hide
            />
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="감소"
              fill={backgroundColors[0]}
              stackId="a"
              stroke="#fff"
            >
              <LabelList
                style={{
                  fill: `${foregroundColors[0]}`,
                  textAlign: 'left',
                  textAnchor: 'start',
                }}
                valueAccessor={() =>
                  values[0] == 0
                    ? ''
                    : `${props.names[0]}: ${values[0]} ${props.unit}`
                }
              />
            </Bar>
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="다소감소"
              fill={backgroundColors[1]}
              stackId="a"
              //stroke="#ccc"
              //label={renderCustomBarLabel}
            >
              <LabelList
                //dataKey="data2"
                style={{ fill: `${foregroundColors[1]}`, textAlign: 'left' }}
                valueAccessor={() =>
                  values[1] == 0
                    ? ''
                    : `${props.names[1]}: ${values[1]} ${props.unit}`
                }
              />
            </Bar>
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="유지"
              fill={backgroundColors[2]}
              stackId="a"
              //stroke="#ccc"
              //label={renderCustomBarLabel}
            >
              <LabelList
                //dataKey="data3"
                style={{ fill: `${foregroundColors[2]}`, textAlign: 'left' }}
                valueAccessor={() =>
                  values[2] == 0
                    ? ''
                    : `${props.names[2]}: ${values[2]} ${props.unit}`
                }
              />
            </Bar>
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="다소증가"
              fill={backgroundColors[3]}
              stackId="a"
              //stroke="#ccc"
              //label={renderCustomBarLabel}
            >
              <LabelList
                //dataKey="data4"
                style={{ fill: `${foregroundColors[3]}` }}
                valueAccessor={() =>
                  values[3] == 0
                    ? ''
                    : `${props.names[3]}: ${values[3]} ${props.unit}`
                }
              />
            </Bar>
            <Bar
              isAnimationActive={false}
              className="bar"
              dataKey="증가"
              fill={backgroundColors[4]}
              stackId="a"
              //stroke="#ccc"
              //label={renderCustomBarLabel}
            >
              <LabelList
                //dataKey="data5"
                style={{ fill: `${foregroundColors[4]}` }}
                valueAccessor={() =>
                  values[4] == 0
                    ? ''
                    : `${props.names[4]}: ${values[4]} ${props.unit}`
                }
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  height: 40px;
  margin-bottom: 15px;

  .bar {
    border: 1px solid #ccc;
  }
`
export default StackProgressChart
